module.exports = __webpack_public_path__ + "static/media/44215.eaa54382.svg";